import { gql } from '@apollo/client';


export const INSERT_LOI_DATA = gql`
 mutation insertLoiData($input: loiDataInput) {
    insertLoiData(input: $input) {
    success
    message
    error
  }
}
`